<template>
  <div class="product-list">
    <div class="product-list-header" @click="productListClick" v-if="title">
      <div class="header-icon"></div>
      <span class="header-title">{{ title }}</span>
      <!-- <span class="header-more">更多</span> -->
    </div>
    <!-- <div class="product-list-body">
			<index-product-body :item="item" :index="index" v-for="(item, index) in items"
				v-bind:key="index"></index-product-body>
		</div> -->
    <swiper :options="swiperOption" ref="mySwiper" class="product-list-body">
      <swiper-slide class="ctab" v-for="(it, id) in items" :key="id">
        <index-product-body
          :item="item"
          :index="index"
          v-for="(item, index) in it"
          :key="index"
        ></index-product-body>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import IndexProductBody from "./IndexProductBody";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "IndexProductList",
  data() {
    return {
      swiperOption: {
        // 设置slidesPerView为你想要显示的slides数量
        spaceBetween: 0, // 分类之间的间距
        loop: false, // 无缝循环
        autoplay: {
          delay: 10000, // 每3秒自动切换
          stopOnLastSlide: false,
          disableOnInteraction: false, // 用户交互后不停止自动播放
        },
        preventClicks: false,
        preventClicksPropagation: false,
        observer: true,
        observeParents: true,
      },
    };
  },
  props: ["items", "title", "type"],
  components: {
    swiper,
    swiperSlide,
    IndexProductBody,
  },
  computed: {},
  methods: {
    productListClick: function () {
      this.$router.push({
        name: "HomeGoodslist",
        query: { sort_key: this.type },
      });
    },
    // productClick: function (goods_id) {
    //   this.$router.push({
    //     name: "HomeGoodsdetail",
    //     query: { goods_id: goods_id },
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.product-list {
  margin-top: $modelSpace;

  .product-list-header {
    background: #ffffff;
    display: flex;
    height: 2rem;
    padding: 0 $pageSpace;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;

    .header-title {
      font-size: $mainFontSize;
      color: #000;
      font-weight: 700;
    }

    .header-icon {
      width: 1rem;
      height: 1rem;
    }

    .header-more {
      font-size: $fontSize;
      color: $descTextColor;
    }
  }

  .product-list-body,
  .ctab {
    display: flex;
    flex-wrap: wrap;
    // padding-right: $pageSpace;
  }
}
</style>
